<div class="logo">
    <img src="/logo.png" alt="Logo" />
  </div>
  